import * as React from 'react';

import { RCComposer } from '@notino/react-rich-content';
import { IComposerData } from '@notino/react-rich-content/dist/types/components/RCComposer/model';
import { SkeletonElement } from '@notino/react-styleguide';
import { GetRichContentByCatalogMasterIdQuery } from '@notino/shared/definitions/types';

import { useRichContentData } from './queries/useRichContentData';
import { RichContentContainer } from './RichContentContainer';
import '@notino/react-rich-content/dist/react-rich-content.css';

// if for ssr errorPolicy on query is to ignored, try parse data safely
const tryGetData = (
  data: GetRichContentByCatalogMasterIdQuery
): IComposerData => {
  try {
    return {
      rich: data.RichContentByCatalogMasterId.content,
      name: '',
    };
  } catch (e) {
    return { rich: { components: [] }, name: '' };
  }
};

interface IRichContentAreaProps {
  versionKey?: string;
}

const RichContentArea: React.FC<IRichContentAreaProps> = ({ versionKey }) => {
  const { loading, error, data } = useRichContentData({ versionKey });

  if (loading) {
    return <SkeletonElement height={15} />;
  }

  if (error || !data?.RichContentByCatalogMasterId?.isAvailable) {
    return null;
  }

  return (
    <RCComposer
      data={tryGetData(data)}
      render={({ rcComponent, error: rcError }) =>
        !rcError && <RichContentContainer rcComponent={rcComponent} />
      }
    />
  );
};

export default RichContentArea;
